module.exports = __webpack_public_path__ + "static/media/undo-green.13746fe8.svg";